<template>
  <div class="cocktails-slider-wrapper" data-scroll>
      <img src="@/assets/img/shmaxicocktailslider.jpg" class="checkers-slider-bg" alt="">
        <swiper ref="mySwiper" :options="swiperOptions">
    <swiper-slide v-for="(slide, index) in _contentData" :key="index">
    
        <img :src="slide.images[0].url" alt="">
        <h2 class="f-21 bold-italic">{{slide.title}}</h2>
        <div class="receipt" @click="openReceiptModal(index)"><span class="f-30">{{$fn.tr('ინგრედიენტები')}}</span></div>
        <ReceiptModal :slide="_contentData" />
    </swiper-slide>
    
    
  </swiper>
  <div class="cocktails-page-slider-next">
<svg xmlns="http://www.w3.org/2000/svg" width="26.204" height="19.07" viewBox="0 0 26.204 19.07">
  <g id="Group_104" data-name="Group 104" transform="translate(0.54 0.535)">
    <g id="menu" transform="translate(0 0)">
      <g id="Group_103" data-name="Group 103">
        <path id="Union_6" data-name="Union 6" d="M11.651,15.232a47.863,47.863,0,0,1,6.08-4.246c.587-.348,1.189-.681,1.808-.97-.9-.037-1.811,0-2.716.037-.962.04-1.912.077-2.82.032-3.919-.212-7.8-.931-11.731-.857C.919,9.251-1.3,7.224.991,7.181c4.459-.083,8.831.8,13.278.9.737.014,1.49,0,2.252-.021a24.421,24.421,0,0,1,5.028.239c-2.2-2.309-4.712-4.311-6.6-6.9-.568-.776-.117-2.053.66-.986,2.278,3.126,5.475,5.4,7.917,8.384a1.282,1.282,0,0,1,.2.348,1.021,1.021,0,0,1,.322.781c0,.034,0,.067,0,.1-.02.588-.86.709-1.7.514a11.6,11.6,0,0,0-4.386,2.012,53.817,53.817,0,0,0-5.009,3.574,1.152,1.152,0,0,1-.735.245C11.529,16.362,10.9,15.848,11.651,15.232Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 1.677)" fill="#fff" stroke="#fff" stroke-width="1"/>
      </g>
    </g>
  </g>
</svg>

  </div>
  <div class="cocktails-page-slider-prev">
<svg xmlns="http://www.w3.org/2000/svg" width="26.204" height="19.07" viewBox="0 0 26.204 19.07">
  <g id="Group_104" data-name="Group 104" transform="translate(25.664 18.534) rotate(180)">
    <g id="menu" transform="translate(0 0)">
      <g id="Group_103" data-name="Group 103">
        <path id="Union_6" data-name="Union 6" d="M11.651,15.232a47.863,47.863,0,0,1,6.08-4.246c.587-.348,1.189-.681,1.808-.97-.9-.037-1.811,0-2.716.037-.962.04-1.912.077-2.82.032-3.919-.212-7.8-.931-11.731-.857C.919,9.251-1.3,7.224.991,7.181c4.459-.083,8.831.8,13.278.9.737.014,1.49,0,2.252-.021a24.421,24.421,0,0,1,5.028.239c-2.2-2.309-4.712-4.311-6.6-6.9-.568-.776-.117-2.053.66-.986,2.278,3.126,5.475,5.4,7.917,8.384a1.282,1.282,0,0,1,.2.348,1.021,1.021,0,0,1,.322.781c0,.034,0,.067,0,.1-.02.588-.86.709-1.7.514a11.6,11.6,0,0,0-4.386,2.012,53.817,53.817,0,0,0-5.009,3.574,1.152,1.152,0,0,1-.735.245C11.529,16.362,10.9,15.848,11.651,15.232Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 1.677)" fill="#fff" stroke="#fff" stroke-width="1"/>
      </g>
    </g>
  </g>
</svg>

  </div>
  
  </div>
</template>

<script>
import ReceiptModal from '@/components/ReceiptModal';
export default {
  props: ['contentData'],
  components: {
    ReceiptModal
  },
 data() {
      return {
        
        swiperOptions: {
          slidesPerView: "auto",
          spaceBetween: 122,
          speed: 800,
          watchOverflow: true,
          grabCursor: true,
           navigation: {
    nextEl: '.cocktails-page-slider-next',
    prevEl: '.cocktails-page-slider-prev',
    disabledClass: 'cocktails-page-slider-disabled',
  
  },

          breakpoints: {
            1920: {
              spaceBetween: 122,
            },
            1440: {
              spaceBetween: 69,
            },
              1366: {
              spaceBetween: 74.7,
               centeredSlides: false,
                 slidesOffsetAfter: 0,
            },

             1024: {
              spaceBetween: 227,
            // centeredSlides: true,
              // loop: true,
              slidesOffsetAfter: 350,
            },
                1000: {
              spaceBetween: 54.1,
            // centeredSlides: true,
              // loop: true,
              slidesOffsetAfter: 250,
            },
            768: {
              spaceBetween: 54.1,
            // centeredSlides: true,
              // loop: true,
              slidesOffsetAfter: 200,
                    centeredSlides: false,
            },
             0: {
              spaceBetween: 54,
            // centeredSlides: true,
              // loop: true,
              // slidesOffsetAfter: 0,
              resistanceRatio: 0,
                  slidesPerView: 1,
              centeredSlides: true,
            }
          }
         
        
        }
      }
    },
    computed: {
      get_load_status(){
        return this.$store.state.main.current_content_request_status;
      },
      _contentData(){
         let _l = [..._.get(this.contentData, 'data.list')]; 
         for (let i = 0; i < _l.length; i++) {
            let n = []
           let newIngredients = {
             newArr: n,
           }
          
           _l[i].newIngredients = newIngredients;
           
           let attr = _l[i].allAttributes;

           let _attr = this.$store.state.main.indx.attributes.ingredients;
           for (let k = 0; k < _attr.length; k++) {
             for (let j = 0; j < attr.length; j++) {
               if(attr[j] == _attr[k].id){
                n.push(_attr[k])

               }
               
             }
             
           }
         }
         return _l;
      },
      swiper() {
        return this.$refs.mySwiper.$swiper
      },
     
    },
    methods: {
      
         openReceiptModal(id) {
      this.$store.commit("main/receiptStatus", !this.$store.state.main.receiptActive);
      this.$store.commit("main/activeReceipt", id);
        
      
    },

    slide_in_sliders(){
      let ss = document.querySelectorAll(".cocktails-slider-wrapper.is-inview .swiper-slide");
      for (let i = 0; i < ss.length; i++) {
          ss[i].style.transitionDelay = `${0.35 * i}s`;
        
      }
      console.log(ss)
      // ss[ss.length -1].addEventListener("transitionend", () => {
      //   ss.forEach(s => {
      //     s.style.transition = "0s"
      //   })
      //   console.log("hsjdgsjhadas")
      //    });
    }
    },
    watch: {
      get_load_status(ns, os){
          if (ns === "done"){
      this.slide_in_sliders(); 
          console.log(ns)
          }
      }
    },
    mounted(){
      console.log(this._contentData);
      if(this.get_load_status === 'done') {
        setTimeout(() => {
            this.slide_in_sliders();
        }, 300);
      }
      // setTimeout(() => {
      //       console.log("loaded")
      // }, 200);

this.$nextTick(() => {
  
})
  
    }
}
</script>

<style lang="scss" scoped>
.cocktails-slider-wrapper{
   .swiper-slide{
    transform: translateX(70%);

 
}
&.is-inview{
    .swiper-slide{
    transform: translateX(0);
        transition: all cubic-bezier(0, 0.08, 0.06, 0.99) 1s;
}
}
}

</style>